import { easyEstimatorApi } from '../easyEstimatorService';

import { ApiUrl } from '~/core/enums';
import { StoreModel } from '~/core/models/store.model';

export type StoreQueryParams = {
  params?: { zipCode: string; storeId?: number };
};

export type ZipcodeLocationResponse = {
  zipCode: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
};

const storesApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchStores: builder.query<StoreModel[], StoreQueryParams>({
      query: ({ params }) => ({
        url: ApiUrl.STORES,
        method: 'GET',
        params,
      }),
    }),
    fetchZipcodeLocation: builder.query<ZipcodeLocationResponse, string>({
      query: (zipCode) => ({
        url: ApiUrl.ZIPCODE_LOCATION,
        method: 'GET',
        params: { zipCode },
      }),
    }),
  }),
});

export const {
  useFetchStoresQuery,
  useFetchZipcodeLocationQuery,
  useLazyFetchZipcodeLocationQuery,
} = storesApi;
